import axios from 'axios'
import { MessageBox, Message, Loading } from 'element-ui'
import store from '@/store'
import router from '@/router'

import qs from 'qs'

const service = axios.create({
  // baseURL: BASE_URL,
  baseURL: '/api',
  timeout: 30000,
})
let loadingInstance
// request interceptor
service.interceptors.request.use(
  (config) => {
    loadingInstance = Loading.service({
      fullscreen: true,
      text: '正在加载中...',
      customClass: 'loading_class',
    })
    config.headers['Content-Type'] = 'multipart/form-data'

    if (config.method === 'post') {
      // config.data = qs.stringify(config.data);
      config.headers['Content-Type'] = 'application/json'
    }

    if (config.contentType) {
      config.headers['Content-Type'] = config.contentType
    }

    const { token } = store.getters
    if (store.getters.token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const {
      data,
      status,
      config: { url },
    } = response
    if (url.includes('export/exportReportPdf')) {
      console.log(response)
    }
    // 如果是下载文件就判断当前的url里面有没有指定的值
    if (
      url.includes('enterprise/downloadCreditReport') ||
      url.includes('file/download') ||
      (url.includes('export/exportReportPdf') && status === 200)
    ) {
      if (loadingInstance) {
        loadingInstance.close()
      }
      if (
        url.includes('export/exportReportPdf') &&
        !data.type.includes('application/pdf')
      ) {
        return {
          code: 500,
          message: '当日此企业信用报告下载达到上限',
        }
      }
      return response.data
    }
    const { message, code, result } = response.data
    if (loadingInstance) {
      loadingInstance.close()
    }
    if (code == 200) {
      return result
    } else {
      Message({
        message: message || 'Error',
        type: 'error',
        duration: 3 * 1000,
      })

      return Promise.reject(new Error(message || 'Error'))
    }
  },
  (error) => {
    console.log('err' + error) // for debug
    if (loadingInstance) {
      loadingInstance.close()
    }
    if (error.response) {
      const { status } = error.response
      if (status === 401) {
        store.dispatch('setToken', undefined)
        Message({
          message: '请先登录',
          type: 'error',
          duration: 3 * 1000,
        })
        router.replace({
          name: 'login',
        })
      } else {
        Message({
          message: error.message,
          type: 'error',
          duration: 3 * 1000,
        })
      }
    } else {
      return Promise.reject(error)
    }
  }
)

export default service
